const CURRENCY_LOCALE: Record<string, string> = {
  BRL: "pt-BR",
  USD: "en-US",
};

export function formatCurrency(currency: string, value: number): string {
  const safe = Number.isFinite(value) ? value : 0;
  const locale = CURRENCY_LOCALE[currency] ?? "pt-BR";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(safe);
  } catch {
    const prefix = currency === "BRL" ? "R$" : currency === "USD" ? "US$" : currency;
    return `${prefix} ${safe.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
}

export function formatPercent(value: number, locale = "pt-BR"): string {
  const safe = Number.isFinite(value) ? value : 0;
  return `${safe.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
}
